// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"efbebc87","368":"8df03c2f","420":"68bf26dd","539":"85ba477e","644":"542abd28","683":"7ac1e1a4","857":"0740fdf4","884":"7261c2d9","945":"92a7ae84"}[chunkId] + ".js";
};